import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import OrgFilters from '../../filters/OrgFilters';
import SettingsFormModal from './SettingsFormModal';
import SettingsTable from './SettingsTable';

// Actions
import { get_all_self_settings } from '../../../redux/actions/selfSettingsActions';

const Settings = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const { isAdminUser } = useSelector(state => state.auth);

	const [orgFilters, setOrgFilters] = useState({ organization: '', workspace: '', module: '' });
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [settingToUpdate, setSettingToUpdate] = useState({});
	const [pageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	// Note: isAdminUser was removed from condition to prevent request with empty filters before OrgFilters restores values from localStorage
	useEffect(() => {
		if (orgFilters.organization !== '') {
			const filters = { ...orgFilters, skip: 0, limit: 0 };
			dispatch(get_all_self_settings(filters));
		}
	}, [orgFilters]);

	const createSetting = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setSettingToUpdate({});
	}

	return (
		<Row justify='center'>
			<Col lg={24} md={24} sm={24} xs={24}>
				<SettingsFormModal
					messageApi={messageApi}
					isModalOpen={isModalOpen}
					setIsModalOpen={setIsModalOpen}
					orgFilters={orgFilters}
					update={update}
					settingToUpdate={settingToUpdate}
					pageSize={pageSize}
					skip={skip}
				/>

				<Row justify='center'>
					<Col lg={8} md={8} sm={24} xs={24}></Col>
					<Col lg={8} md={8} sm={24} xs={24}>
						<Typography.Title className='text-center' level={2}>{t('settings.title')}</Typography.Title>
					</Col>
					<Col style={{ textAlign: 'end' }} lg={8} md={8} sm={24} xs={24}>
						<Button
							type='primary'
							size='large'
							onClick={() => createSetting()}
						>
							{t('settingsForm.create.title').split(' ')[0]}
						</Button>
					</Col>
				</Row>

				<Row justify='center'>
					<Col lg={17} md={17} sm={24} xs={24}>
						<OrgFilters
							orgFilters={orgFilters}
							setOrgFilters={setOrgFilters}
							displayFilters={{ organization: true, workspace: true, module: true }}
						/>
					</Col>
				</Row>

				<SettingsTable
					messageApi={messageApi}
					orgFilters={orgFilters}
					setIsModalOpen={setIsModalOpen}
					setUpdate={setUpdate}
					setSettingToUpdate={setSettingToUpdate}
					pageSize={pageSize}
					skip={skip}
					setSkip={setSkip}
				/>
			</Col>
		</Row>
	);
}

Settings.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Settings;
